import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';
import { CompanyAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';

@Injectable()
export class AdminOfCompanyService {
    constructor(private authService: AuthService, private http: Http) { }
    private JQueryHelper: JQueryHelperService = new JQueryHelperService();
    public GetAdminOfCompanyList(companyHashID: string, input?: DataListModel): Observable<IAPIResponse> {
        let getInstanceAdminUrl = WeGoConfig.API_GET_ADMIN_OF_COMPANY_LIST;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getInstanceAdminUrl = getInstanceAdminUrl + "?" + queryString + "&companyHashID=" + companyHashID;
        }
        else {
            getInstanceAdminUrl = getInstanceAdminUrl + "?companyHashID=" + companyHashID;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getInstanceAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfCompany(companyHashID: string, selectedAdminOfCustomerList: string[]): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfInstance = WeGoConfig.API_POST_DELETE_ADMIN_OF_COMPANY + "?companyHashID=" + companyHashID;

        return this.http.post(urlDeleteAdminOfInstance, selectedAdminOfCustomerList, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ExportAdminOfCompanyList(companyHashID: string, input?: DataListModel): any {
        input.currentPage = 0;
        let queryString = this.authService.HandleAPIListInput(input);
        let exportToCSVInstanceAdminUrl = WeGoConfig.API_EXPORT_ADMIN_OF_COMPANY_LIST + "?" + queryString + "&companyHashID=" + companyHashID;
        let headers = this.authService.GetHeader('text/csv');
        let options = new RequestOptions({ headers: headers });
        return this.http.get(exportToCSVInstanceAdminUrl, options);
    }

    public GetAllRoleAvailability(input?: DataListModel, companyHashID?: string): Observable<IAPIResponse> {
        let getRoleAvailabilityListUrl = WeGoConfig.API_GET_COMPANY_ROLEAVAILABILITY_LIST + "?companyHashID=" + companyHashID;
        let queryString = this.authService.HandleAPIListInput(input);
        if (queryString) {
            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
        }
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getRoleAvailabilityListUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public DeleteAdminOfInstanceRole(companyHashID: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlDeleteAdminOfInstance = WeGoConfig.API_POST_DELETE_ADMIN_OF_COMPANY_ROLE + "?companyHashID=" + companyHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;

        return this.http.get(urlDeleteAdminOfInstance, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public AddAdminOfInstanceRole(companyHashID: string, personHashId: string, roleHashId: string): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlAddAdminOfInstance = WeGoConfig.API_POST_ADD_ADMIN_OF_COMPANY_ROLE + "?companyHashID=" + companyHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;;

        return this.http.get(urlAddAdminOfInstance, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public GetPersonListToInvite(companyHashID: string, emailAddress: string): Observable<IAPIResponse> {
        let getComapanyAdminUrl = WeGoConfig.API_GET_COMPANY_PERSON_TO_INVITE_LIST;

        getComapanyAdminUrl = getComapanyAdminUrl + "?companyHashID=" + companyHashID + "&emailAddress=" + emailAddress;

        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http.get(getComapanyAdminUrl, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public InviteAdminOfInstance(companyAdminInvitationModel: CompanyAdminInvitationModel): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        let urlInviteAdminOfCompany = WeGoConfig.API_POST_INVITE_ADMIN_OF_COMPANY;

        return this.http.post(urlInviteAdminOfCompany, companyAdminInvitationModel, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-company/models/admin-of-company.service.ts